module.exports = __webpack_public_path__ + "static/media/mandolin.0e8ccb2c.svg";